<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6" @click="showModal(1)">
                    <stats-card id="totalSpecialization" title="Specialization"
                                type="gradient-red"
                                :sub-title="totalSpecialization"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(2)">
                    <stats-card id="totalPositionLevel" title="Position Level"
                                type="gradient-orange"
                                :sub-title="totalPositionLevel"
                                class="mb-4 mb-xl-0"
                                >
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(3)">
                    <stats-card id="totalIndustry" title="Industry"
                                type="gradient-orange"
                                :sub-title="totalIndustry"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(4)">
                    <stats-card id="totalDressCode" title="Dress Code"
                                type="gradient-orange"
                                :sub-title="totalDressCode"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
            <br />
            <div class="row">
              <div class="col-xl-3 col-lg-6" @click="showModal(5)">
                    <stats-card id="totalCompanySize" title="Company Size"
                                type="gradient-orange"
                                :sub-title="totalCompanySize"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(6)">
                    <stats-card id="totalSpokenLanguage" title="Spoken Language"
                                type="gradient-orange"
                                :sub-title="totalSpokenLanguage"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <!-- <div class="col-xl-3 col-lg-6" @click="showModal(7)">
                    <stats-card id="totalQualification" title="Qualification"
                                type="gradient-orange"
                                :sub-title="totalQualification"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div> -->
                <div class="col-xl-3 col-lg-6" @click="showModal(8)">
                    <stats-card id="totalJobType" title="Job Type"
                                type="gradient-orange"
                                :sub-title="totalJobType"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7" v-if="modal.specialization == true">
            <div class="row">
                <div class="col">
                  <specializations-table></specializations-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.positionLevel == true">
            <div class="row">
                <div class="col">
                  <position-levels-table></position-levels-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.industry == true">
            <div class="row">
                <div class="col">
                  <industries-table></industries-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.dressCode == true">
            <div class="row">
                <div class="col">
                  <dress-codes-table></dress-codes-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.companySize == true">
            <div class="row">
                <div class="col">
                  <company-sizes-table></company-sizes-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.spokenLanguage == true">
            <div class="row">
                <div class="col">
                  <spoken-languages-table></spoken-languages-table>
                </div>
            </div>
        </div>

        <!-- <div class="container-fluid mt--7"  v-if="modal.qualification == true">
            <div class="row">
                <div class="col">
                  <qualifications-table></qualifications-table>
                </div>
            </div>
        </div> -->

        <div class="container-fluid mt--7"  v-if="modal.jobType == true">
            <div class="row">
                <div class="col">
                  <job-types-table></job-types-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import SpecializationsTable from './Tables/SpecializationsTable';
  import PositionLevelsTable from './Tables/PositionLevelsTable';
  import IndustriesTable from './Tables/IndustriesTable';
  import DressCodesTable from './Tables/DressCodesTable';
  import CompanySizesTable from './Tables/CompanySizesTable';
  import SpokenLanguagesTable from './Tables/SpokenLanguagesTable';
  import QualificationsTable from './Tables/QualificationsTable';
  import JobTypesTable from './Tables/JobTypesTable';
  import EventBus from './../event-bus';
  export default {
    name: 'tables',
    components: {
      SpecializationsTable,
      PositionLevelsTable,
      IndustriesTable,
      DressCodesTable,
      CompanySizesTable,
      SpokenLanguagesTable,
      QualificationsTable,
      JobTypesTable
    },
    data() {
        return {
            totalSpecialization: "0",
            totalPositionLevel: "0",
            totalIndustry: "0",
            totalDressCode: "0",
            totalCompanySize: "0",
            totalSpokenLanguage: "0",
            totalQualification: "0",
            totalJobType: "0",
            modal: {
              specialization: true,
              positionLevel: false,
              industry: false,
              dressCode: false,
              companySize: false,
              spokenLanguage: false,
              qualification: false,
              jobType: false
            }
        }
    },
    mounted() {
      $('#settingsToggle').attr("aria-expanded","true");
      $('#settings').show();
      this.getTotalSpecialization();
      this.getTotalPositionLevel();
      this.getTotalIndustry();
      this.getTotalDressCode();
      this.getTotalCompanySize();
      this.getTotalSpokenLanguage();
      this.getTotalQualification();
      this.getTotalJobType();
      EventBus.$on('updateSpecializationCount', () => {
        this.getTotalSpecialization();
      });
      EventBus.$on('updatePositionLevelCount', () => {
        this.getTotalPositionLevel();
      }); 
      EventBus.$on('updateIndustryCount', () => {
        this.getTotalIndustry();
      }); 
      EventBus.$on('updateDressCodeCount', () => {
        this.getTotalDressCode();
      }); 
      EventBus.$on('updateCompanySizeCount', () => {
        this.getTotalCompanySize();
      });
      EventBus.$on('updateSpokenLanguageCount', () => {
        this.getTotalSpokenLanguage();
      }); 
      EventBus.$on('updateQualificationCount', () => {
        this.getTotalQualification();
      }); 
      EventBus.$on('updateJobTypeCount', () => {
        this.getTotalJobType();
      });
      $('#totalSpecialization').addClass('bg-yellow');
      $('#totalPositionLevel').removeClass('bg-yellow');
      $('#totalIndustry').removeClass('bg-yellow');
      $('#totalDressCode').removeClass('bg-yellow');
      $('#totalCompanySize').removeClass('bg-yellow');
      $('#totalSpokenLanguage').removeClass('bg-yellow');
      $('#totalQualification').removeClass('bg-yellow');
      $('#totalJobType').removeClass('bg-yellow');
    },
    methods: {

      showModal : function (value) 
      {
        this.$router.push({ query: { page: 1 } });
        if (value == 1) {
          this.modal.specialization = true;
          this.modal.positionLevel = false;
          this.modal.industry = false;
          this.modal.dressCode = false;
          this.modal.companySize = false;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').addClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');

        } else if (value == 2) {
          this.modal.specialization = false;
          this.modal.positionLevel = true;
          this.modal.industry = false;
          this.modal.dressCode = false;
          this.modal.companySize = false;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').addClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');
        } else if (value == 3) {
          this.modal.specialization = false;
          this.modal.positionLevel = false;
          this.modal.industry = true;
          this.modal.dressCode = false;
          this.modal.companySize = false;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').addClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');
        } else if (value == 4) {
          this.modal.specialization = false;
          this.modal.positionLevel = false;
          this.modal.industry = false;
          this.modal.dressCode = true;
          this.modal.companySize = false;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').addClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');
        } else if (value == 5) {
          this.modal.specialization = false;
          this.modal.positionLevel = false;
          this.modal.industry = false;
          this.modal.dressCode = false;
          this.modal.companySize = true;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').addClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');
        } else if (value == 6) {
          this.modal.specialization = false;
          this.modal.positionLevel = false;
          this.modal.industry = false;
          this.modal.dressCode = false;
          this.modal.companySize = false;
          this.modal.spokenLanguage = true;
          this.modal.qualification = false;
          this.modal.jobType = false;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').addClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').removeClass('bg-yellow');
        } else if (value == 8) {
          this.modal.specialization = false;
          this.modal.positionLevel = false;
          this.modal.industry = false;
          this.modal.dressCode = false;
          this.modal.companySize = false;
          this.modal.spokenLanguage = false;
          this.modal.qualification = false;
          this.modal.jobType = true;
          $('#totalSpecialization').removeClass('bg-yellow');
          $('#totalPositionLevel').removeClass('bg-yellow');
          $('#totalIndustry').removeClass('bg-yellow');
          $('#totalDressCode').removeClass('bg-yellow');
          $('#totalCompanySize').removeClass('bg-yellow');
          $('#totalSpokenLanguage').removeClass('bg-yellow');
          $('#totalQualification').removeClass('bg-yellow');
          $('#totalJobType').addClass('bg-yellow');
        }
        // else if (value == 7) {
        //   this.modal.specialization = false;
        //   this.modal.positionLevel = false;
        //   this.modal.industry = false;
        //   this.modal.dressCode = false;
        //   this.modal.companySize = false;
        //   this.modal.spokenLanguage = false;
        //   this.modal.qualification = true;
        //   $('#totalSpecialization').removeClass('bg-yellow');
        //   $('#totalPositionLevel').removeClass('bg-yellow');
        //   $('#totalIndustry').removeClass('bg-yellow');
        //   $('#totalDressCode').removeClass('bg-yellow');
        //   $('#totalCompanySize').removeClass('bg-yellow');
        //   $('#totalSpokenLanguage').removeClass('bg-yellow');
        //   $('#totalQualification').addClass('bg-yellow');
        //   $('#totalJobType').removeClass('bg-yellow');
        // } 

      },

      getTotalSpecialization()
      {
        this.$store.dispatch('fetchTotalSpecialization', {})
        .then (response => {
          this.totalSpecialization = response.data.toString();
        });
      },

      getTotalPositionLevel()
      {
        this.$store.dispatch('fetchTotalPositionLevel', {})
        .then (response => {
          this.totalPositionLevel = response.data.toString();
        });
      },

      getTotalIndustry()
      {
        this.$store.dispatch('fetchTotalIndustry', {})
        .then (response => {
          this.totalIndustry = response.data.toString();
        });
      },

      getTotalDressCode()
      {
        this.$store.dispatch('fetchTotalDressCode', {})
        .then (response => {
          this.totalDressCode = response.data.toString();
        });
      },

      getTotalCompanySize()
      {
        this.$store.dispatch('fetchTotalCompanySize', {})
        .then (response => {
          this.totalCompanySize = response.data.toString();
        });
      },

      getTotalSpokenLanguage()
      {
        this.$store.dispatch('fetchTotalSpokenLanguage', {})
        .then (response => {
          this.totalSpokenLanguage = response.data.toString();
        });
      },

      getTotalQualification()
      {
        this.$store.dispatch('fetchTotalQualification', {})
        .then (response => {
          this.totalQualification = response.data.toString();
        });
      },

      getTotalJobType()
      {
        this.$store.dispatch('fetchTotalJobType', {})
        .then (response => {
          this.totalJobType = response.data.toString();
        })
      }
    }
  };
</script>
<style></style>
